"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 7v10a4 4 0 0 0 4 4h10c2.21 0 4-1.789 4-3.998V6.996A3.996 3.996 0 0 0 17 3H7a4 4 0 0 0-4 4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--neutral--200,#a8acbd))",
  d: "M15.173 4.4H8.85v10.505a.5.5 0 0 0 .828.378L11.7 13.53a.5.5 0 0 1 .657.002l1.986 1.74a.5.5 0 0 0 .83-.375z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CollectionSingleFillIcon24.js.map